module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_kimono-573a0729e8e9e0313df2fa9b704f726c.webp";